import React, { createContext, useContext } from 'react';

type AssistantDrawerAPI = {
  open: () => void;
  close: () => void;
  toggle: () => void;
  isOpen: boolean;
  isEnabled: boolean;
  conversationActive: boolean;
  setConversationActive: (active: boolean) => void;
};

const AssistantDrawerContext = createContext<AssistantDrawerAPI | null>(null);

export const useAssistantDrawer = (): AssistantDrawerAPI => {
  const ctx = useContext(AssistantDrawerContext);
  if (!ctx) {
    throw new Error('AssistantDrawerProvider is not detected. Wrap your tree with <AssistantDrawerProvider>.');
  }
  return ctx;
};

export const AssistantDrawerProvider = AssistantDrawerContext.Provider;

export type { AssistantDrawerAPI };
